(function () {
	'use strict';

	var module = angular.module('uwAgenda.users');
	module.directive('nationalNumberValidation', ['HelperService', NationalNumberValidationFn]);

	function NationalNumberValidationFn(HelperService) {

		var directive = {
			require: 'ngModel',
			restrict: 'A',
			scope: {
				
			},
			link: link
		};
		return directive;

		function link(scope, element, attrs, ctrl) {
		
			ctrl.$validators.nationalNumberValid = function (value) {
				if (!value) {
					return  true;
				}

				return HelperService.validateNationalNumber(value);
			};		
		}
	}
})();